import * as React from 'react';

import { SVGProps } from './type';

const SvgComponent = (props: SVGProps) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm6 10a1 1 0 0 0 1-1 7 7 0 1 0-14 0 1 1 0 0 0 1 1"
      fill={props.color}
    />
  </svg>
);

export default SvgComponent;
